import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment-timezone';
import { isNullOrUndefined } from '../utils';

export class DateValidators {
  static isSameOrAfter(
    compareDate: Date,
    format?: string,
    unit?: 'year' | 'month' | 'week' | 'isoWeek' | 'day' | 'hour' | 'minute' | 'second'
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const validationErrors: ValidationErrors = {};

      if (!isNullOrUndefined(control.value)) {
        if (!moment(control.value, format).isValid()) {
          validationErrors['invalidDate'] = true;
        } else if (!moment(control.value, format).isSameOrAfter(moment(compareDate, format), unit)) {
          validationErrors['dateIsBeforeCutOff'] = true;
        }
      }

      return validationErrors;
    };
  }
}
